import styled, { keyframes } from 'styled-components';
import { Link as LinkR } from 'react-router-dom';
import { Link as LinkS } from 'react-scroll';
import { MdKeyboardArrowRight, MdArrowForward } from 'react-icons/md';
import theme from '../../const/theme';

const anim4 = keyframes`
    from{
        margin-top: -100%
    }
    to{
        margin-top: 0%;
    }
`
const anim1 = keyframes`
     from {
         margin-left:0;
         opacity: 1;
         display: block;
         }
    to {
        margin-left:-50px;
        opacity: 0;
        display: none;
        }
`
const anim2 = keyframes`
     from {
         opacity: 0;
         }
    to {
        opacity: 1;
        }
`
const blinker = keyframes`
     50% {
      opacity: 0;
    }
`
const blur = keyframes` 
0% { -webkit-filter: blur(0px);}
4% { -webkit-filter: blur(1px);}
5% { -webkit-filter: blur(0px);}
10% { -webkit-filter: blur(3px);}
15% { -webkit-filter: blur(1px);}
16% { -webkit-filter: blur(0px);}
20% { -webkit-filter: blur(0px);}
20% { -webkit-filter: blur(0px);}
`
const blur2 = keyframes` 
23% { -webkit-filter: blur(0px);}
24% { -webkit-filter: blur(1px);}
25% { -webkit-filter: blur(0px);}
26% { -webkit-filter: blur(5px);}
27% { -webkit-filter: blur(0px);}
28% { -webkit-filter: blur(1px);}
35% { -webkit-filter: blur(0px);}
80% { -webkit-filter: blur(0px);}
81% { -webkit-filter: blur(5px);}
87% { -webkit-filter: blur(0px);}
88% { -webkit-filter: blur(5px);}
89% { -webkit-filter: blur(0px);}
`

export const Nav = styled.nav`
    margin-top: -140px;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    font-size: 1rem;
    position: sticky;
    top: 0%;
    z-index: 10;

    @media screen and (max-width: 960px){
        transition: 0.8s all ease;
    }

    @media screen and (max-width: 768px){
        height:60px;
    }
`

export const Container = styled.div`
    display: flex;
    flex-direction: row;
`


export const NavbarMenu = styled.div`
    background-color: ${({scroll}) => (scroll ? theme.COLORS.PRIMARY : 'transparent')};
    display: flex;
    justify-content: center;
    width: 100%;
    padding:  ${({ scroll }) => (scroll ? '25px' : '50px')};

    z-index: 1;
    transition: .5s ease-in-out 0s;
    @media screen and (max-width: 768px){
        padding: 20px 10px;

    }
    

`
export const MenuContainer = styled.div`
    height: ${({ scroll }) => (scroll ? '1em' : '2.5em')};
    display: flex;
    justify-content: space-between;
    width:100%;
    max-width: 990px;

`

export const NavLogo = styled(LinkR)`
    justify-self: flex-start;
    justify-content: flex-start;
    align-items: center;
    flex-direction: row;
    cursor: pointer;
    display: flex;
    text-decoration: none;
    margin-top: -100%;
    animation: ${anim4} 2s forwards 1s;
`
export const LogoContainer = styled.div`
    align-items: center;
    flex-direction: ${({ scroll }) => (scroll ? 'row' : 'column')};;
    display: flex;
`

export const Logo = styled.img.attrs(props => ({src: props.scroll ? props.image2 : props.image}))`
       width: ${({ scroll }) => (scroll ? '10rem' : '16rem')};
       transition: .3s ease-in-out 0s;
       margin-right: 30px;
       margin-top: ${({ scroll }) => (scroll ? '0' : '2.5rem')};
       
   
       @media screen and (max-width: 991px){
           margin-right: 20px;
   
       }

    @media screen and (max-width: 768px){
        width: 9rem;
        margin-right: 20px;
        margin-top: ${({ scroll }) => (scroll ? '0' : '1.25rem')};


    }

    @media screen and (max-width: 380px){
        width: 5rem;
        margin-top: ${({ scroll }) => (scroll ? '0px' : '-20px')};

    }
`
export const Image = styled.img`
       width: ${({ width }) => (width ? width : '16rem')};
       transition: .3s ease-in-out 0s;
   
       @media screen and (max-width: 991px){
        width: 3;
   
       }

    @media screen and (max-width: 768px){
        width: 2.2rem;
    }

    @media screen and (max-width: 380px){
       // width: 5rem;
        margin-top: ${({ scroll }) => (scroll ? '0px' : '-20px')};

    }
`

export const NavH3 = styled.h3`
margin-top: -5px;
    font-size: 1.5rem;
    font-family: 'Exo 2', sans-serif;
    color: #fff;
    text-transform: uppercase;
    @media screen and (max-width: 380px){
        font-size: 1rem;
    }
`

export const Img = styled.img`
    height:50px;
    margin: 0 0 10px 0;
    padding-right: 0;
`
export const MobileIcon = styled.div`
    display: none;

    @media screen and (max-width: 768px){
        display: block;
        color: white;
        position: absolute;
        top: -15px;
        right: 0; 
        transform: translate(-100%, 60%); 
        font-size: 1.8rem;
        cursor: pointer;
    }
    @media screen and (max-width: 380px){
        top: 5px;
        font-size: 1rem;
    }

`
export const NavMenuContainer =styled.div`
     display: flex;
     flex-direction: row;

`

export const NavMenu = styled.ul`
    display: flex;
    align-items: center;
    justify-content: end;
    padding-left: 15px;
    list-style: none;
    text-align: center;
    margin-top: -100%;
    animation: ${anim4} 2s forwards 1s;
    z-index: 1;
    @media screen and (max-width: 768px){
        display: none;
    }
`


export const NavItem = styled.li`
    height:30px;
    //animation: ${({noeffect}) => (noeffect ? `` : blur)} 10s infinite; 
`

export const NavLinks = styled(LinkS)`
    display: flex;
    align-items: center;
    text-decoration: none;
    padding: 0 0 0 1.1rem;
    height: 100%;
    cursor: pointer;
    font-family: 'Roboto-regular', sans-serif; 
    /* letter-spacing: .05em; */
    font-weight: 800;
    font-size: .8rem;
    /* text-transform: uppercase; */
    transition: .3s ease-in-out 0s;
    color: #ffffff;
   
    border-bottom: ${({whiteline}) => (whiteline ? '3px solid white' : 'none')}; 
    &.active{
        border-bottom: 3px solid white;
        background-color: transparent;
    }
    &:hover{
        border-bottom: 3px solid white;
        text-shadow:
        0 0 7px #fff,
        0 0 10px #fff,
        0 0 21px #fff,
        0 0 42px #0fa,
        0 0 82px #0fa,
        0 0 92px #0fa,
        0 0 102px #0fa,
        0 0 151px #0fa;
    }
`
export const NavLinksCode = styled(LinkS)`
opacity: 0;
    display: flex;
    align-items: center;
    text-decoration: none;
    padding: 0 0 0 1.5rem;
    height: 100%;
    cursor: pointer;
    font-family: 'Barlow Condensed', sans-serif; 
    letter-spacing: .05em;
    font-weight: 500;
    font-size: 1.1rem;
    text-transform: uppercase;
    transition: .3s ease-in-out 0s;
    color: #dddddd;
    animation-delay: 2s;
    -webkit-animation:${anim1} 4s ;  /* Chrome, Safari, Opera */
    animation: ${anim1} 4s;
    -webkit-animation-timing-function: linear;  /* Chrome, Safari, Opera */
    animation-timing-function: linear;
`

export const NavBtn = styled.nav`
    display: flex;
    align-items: right;
    margin-top: -100%;
    animation: ${anim4} 2s forwards 1s;
    margin-left: 42px;
    margin-right: 5px;

    padding-bottom: 10px;

    @media screen and (max-width: 768px){
        display: none;
    }
`


export const ArrowFoward = styled(MdArrowForward)`
    margin-left: 8px;
    font-size: 20px;
`

export const ArrowRight = styled(MdKeyboardArrowRight)`
    margin-left: 8px;
    font-size: 20px;
`